<template>
    <Head :title="$t('auth.invalidInvite')" />

    <jet-authentication-card class="bg-minplan-blue">
        <template #logo>
            <img class="h-8 w-auto" src="../../../image/immivo.svg" alt="immivo" />
        </template>

        <div class="mb-4 text-sm text-gray-600">
            {{ $t("auth.invalidInvite") }}
        </div>
        <p>{{ $t("auth.contactConsultant") }}</p>
    </jet-authentication-card>
</template>

<script>
import { Head } from "@inertiajs/inertia-vue3";
import JetAuthenticationCard from "@/Jetstream/AuthenticationCard.vue";
import JetAuthenticationCardLogo from "@/Jetstream/AuthenticationCardLogo.vue";

export default {
    components: {
        Head,
        JetAuthenticationCard,
        JetAuthenticationCardLogo,
    },
};
</script>

<style scoped></style>
